import { useQueryState } from 'nuqs';
import { queryStateParser, queryParam, QueryStateSchema } from './queryStateParser';

const useIsPaneOpen = (check: {
  type: QueryStateSchema['type'];
  id?: QueryStateSchema['id'];
}): boolean => {
  const [state] = useQueryState(queryParam, queryStateParser);

  if (!state) {
    return false;
  }

  return Boolean(state.find(s => {
    if (s.type !== check.type) {
      return false;
    }
    if (check.id && s.id !== check.id) {
      return false;
    }
    return true;
  }));
};

export default useIsPaneOpen;